import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';
import { monthNames } from '../../i18n/calendarLabels';
import SearchableSelect from "../common/SearchableSelect";
import ClientSettlementsFilters from './ClientSettlementsFilters';

function ClientSettlementsReportForm({
  month,
  monthOptions,
  clientId,
  clientOptions,
  showDraft,
  showApproved,
  showNegativeBalanceOnly,
  showEmptyClients,
  watchdog,
  onChange,
  onClearFilters,
  onApplyFilters,
}) {
  const { t: tr, i18n } = useTranslation();
  return (
    <div className="mb-4">
      <div className="form-row align-items-end">
        <div className="col-md-4">
          <SearchableSelect
            label={tr("manage:month_133")}
            name="month"
            value={month}
            onChange={onChange}
            options={monthOptions.map(option => ({ ...option, text: i18n.language === 'en' ? `${monthNames('en')[Number(option.value.slice(5, 7)) - 1]} ${option.value.slice(0, 4)}` : option.text }))}
            placeholder={tr("billing:selectAMonth_121")}
            isClearable={false}
          />
        </div>
        <div className="col-md-4">
          <SearchableSelect
            label={tr("manage:client_108")}
            name="clientId"
            value={clientId}
            onChange={onChange}
            options={clientOptions}
            placeholder={tr("billing:everyone_122")}
            clearValue="all"
          />
        </div>
        <ClientSettlementsFilters filters={{ showDraft, showApproved, showNegativeBalanceOnly, showEmptyClients, watchdog }} onApply={onApplyFilters} onClear={onClearFilters} />
      </div>
    </div>
  );
}

ClientSettlementsReportForm.propTypes = {
  month: PropTypes.string.isRequired,
  monthOptions: PropTypes.array.isRequired,
  clientId: PropTypes.string.isRequired,
  clientOptions: PropTypes.array.isRequired,
  showDraft: PropTypes.bool.isRequired,
  showApproved: PropTypes.bool.isRequired,
  showNegativeBalanceOnly: PropTypes.bool.isRequired,
  showEmptyClients: PropTypes.bool.isRequired,
  watchdog: PropTypes.shape({
    enabledOnly: PropTypes.bool.isRequired,
    minAmount: PropTypes.string.isRequired,
    minOverdueDays: PropTypes.string.isRequired,
    priority: PropTypes.string.isRequired,
    followUpStatus: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
  onApplyFilters: PropTypes.func.isRequired,
};

export default ClientSettlementsReportForm;
